
export class DocumentUploadRequest {

    public userType = ""
    public firstName = "";
    public lastName = "";
    public contractNumber = "";
    public claimNumber = "";

    public email = "";
    public phoneNumber = "";    
    public message = "";
}